/**
 * UserList — shows online users with call/chat actions
 */

import React from 'react';
import type { OnlineUser } from '../hooks/usePresence';

interface Props {
  users: OnlineUser[];
  currentUserId: string;
  onCall:  (userId: string) => void;
  onChat:  (userId: string) => void;
}

export const UserList: React.FC<Props> = ({ users, currentUserId, onCall, onChat }) => {
  if (users.length === 0) {
    return (
      <div className="user-list user-list--empty">
        <p>No other users online</p>
      </div>
    );
  }

  return (
    <div className="user-list">
      <h2 className="user-list__title">Online ({users.length})</h2>
      <ul className="user-list__items">
        {users.map((u) => (
          <li key={u.id} className="user-list__item">
            <div className="user-list__avatar">
              {u.avatar_url ? (
                <img src={u.avatar_url} alt={u.display_name} />
              ) : (
                <span className="user-list__initials">
                  {u.display_name.charAt(0).toUpperCase()}
                </span>
              )}
              <span className="user-list__status-dot" aria-label="Online" />
            </div>
            <div className="user-list__info">
              <span className="user-list__name">{u.display_name}</span>
              <span className="user-list__username">@{u.username}</span>
            </div>
            <div className="user-list__actions">
              <button
                className="btn btn--icon btn--call"
                title="Voice call"
                onClick={() => onCall(u.id)}
                disabled={u.id === currentUserId}
              >
                📞
              </button>
              <button
                className="btn btn--icon btn--chat"
                title="Send message"
                onClick={() => onChat(u.id)}
                disabled={u.id === currentUserId}
              >
                💬
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
